/* eslint-disable max-classes-per-file */
export interface RequestExperienceEventInterface {
  subCategorySlug: string;
  sportTeamSlug: string;
}

export class Price {
  sku: string = "";

  packageName: string = "";

  type: string = "";

  nameEn: string = "";

  nameTh: string = "";

  price: number = 0;

  originalPrice: number = 0;

  exclusivePrice: number = 0;

  currency: string = "";

  constructor(data: any) {
    this.sku = data?.sku || "";
    this.packageName = data?.packageName || "";
    this.type = data?.type || "";
    this.nameEn = data?.nameEn || "";
    this.nameTh = data?.nameTh || "";
    this.price = data?.price || 0;
    this.originalPrice = data?.originalPrice || 0;
    this.exclusivePrice = data?.exclusivePrice || 0;
    this.currency = data?.currency || "";
  }
}

export class DetailExperienceEventRecentlyView {
  name: string = "";

  slug: string = "";

  areaName: string = "";

  areaSlug: string = "";

  cityName: string = "";

  citySlug: string = "";

  countryName: string = "";

  countrySlug: string = "";

  tier: string = "";

  ticketType: string = "";

  isExclusive: boolean = false;

  klubCategory: string = "";

  category: string = "";

  prices: Price;

  isActive: number = 0;

  textRating: string = "";

  reviewRating: {
    rating: number;
    textRatingDetail: string;
    numReviews: number;
  };

  photo: string[] = [];

  sportTeamSlug: string = "";

  subCategorySlug: string = "";

  createDate: string = "";

  categorySlug: string = "";

  isGreenCertificate?: boolean;

  constructor(data: any) {
    this.isGreenCertificate = data?.isGreenCertificate || false;
    this.name = data?.name || "";
    this.slug = data?.slug || "";
    this.areaName = data?.areaName || "";
    this.areaSlug = data?.areaSlug || "";
    this.cityName = data?.cityName || "";
    this.citySlug = data?.citySlug || "";
    this.countryName = data?.countryName || "";
    this.countrySlug = data?.countrySlug || "";
    this.tier = data?.tier || "";
    this.ticketType = data?.ticketType || "";
    this.isExclusive = data?.isExclusive || false;
    this.klubCategory = data?.klubCategory || "";
    this.category = data?.category || "";
    this.prices = new Price(data?.prices || {});
    this.isActive = data?.isActive || 1;
    this.textRating = data?.textRating || "";
    this.reviewRating = {
      rating: data.reviewRating?.rating || 0,
      textRatingDetail: data.reviewRating?.textRatingDetail || "",
      numReviews: data.reviewRating?.numReviews || 0,
    };

    this.photo = (data?.photo || []).map((url: string) => url);
    this.sportTeamSlug = data?.sportTeamSlug || "";
    this.subCategorySlug = data?.subCategorySlug || "";
    this.createDate = data?.createDate || "";
    this.categorySlug = data?.categorySlug || "";
  }
}

export class ExperienceEventRecentlyViewResponse {
  status: boolean = false;

  data: DetailExperienceEventRecentlyView[];

  constructor(data: any) {
    this.status = data?.status || false;
    this.data = (data?.data || []).map(
      (value: any) => new DetailExperienceEventRecentlyView(value),
    );
  }
}
